import React, { useMemo } from "react";
import { useForm } from "react-hook-form";
import { Form, Button, Row, Col } from "react-bootstrap";
import DommusRequiredSpan from "../../../../components/DommusRequiredSpan";
import "./index.scss";

export function ExemplosTagsTemplate({ mensagem, handleSubmitForm, closeModal }) {
  const tagsUnicas = useMemo(() => {
    if(mensagem){
      const matches = mensagem?.match(/\[[^\[\]]+\]/g) ?? [];
      return [...new Set(matches)];
    }
    return [];
  }, [mensagem]);

  const { register, handleSubmit, formState: { errors } } = useForm();

  const handleOnSubmit = (data) => {
    handleSubmitForm(data, true);
    closeModal();
  };

  return (
    <Form onSubmit={handleSubmit(handleOnSubmit)} className="form-tags-exemplos">
      <Row className="fields-section">
        {tagsUnicas.map((tag, index) => {
          const nome = tag.slice(1, -1);
          return (
            <Col md={12} key={index} className="mb-3">
              <Form.Group>
                <Form.Label className="label-tag">
                  Exemplos para a TAG: <span>{tag} <DommusRequiredSpan /></span>
                </Form.Label>
                <Form.Control
                  type="text"
                 {...register(nome, { required: true })}
                />
                {errors[nome] && (
                  <small className="form-text text-danger">Campo Obrigatório*</small>
                )}
              </Form.Group>
            </Col>
          );
        })}
      </Row>
      <Row className="footer">
        <Col className="d-flex justify-content-end">
          <Button type="submit" variant="success">
            Enviar
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

